export default __webpack_public_path__ + "static/media/error404.35b52f76.png";